import { GoalTypeEnum } from "../enum";
import { IGoalType, IListGoalsAndDataDto } from "../interfaces";
import BaseApi from "./BaseApi";

const baseUrl = 'api/goal/';

interface IGoalNew {
    type: number;
    value: number|string;
    proposalTypeId?: number;
}

interface IUpdateStatus {
    goalId: number;
    statusId: number;
}

interface IResponse {
    success: boolean;
    errors: string[];
}

interface IGoal {
    id: number;
    typeId: GoalTypeEnum;
    statusId: number;
    value: number;
    proposalTypeId?: number;
    proposalTypeName: string;
}

class GoalService {
    // #region GET
    static async GetGoals(): Promise<IListGoalsAndDataDto> {
        return await BaseApi.get(`${baseUrl}list`);
    }
    static async GetGoalById(id: string): Promise<IGoal> {
        return await BaseApi.get(`${baseUrl}${id}`);
    }
    static async GetGoalsType(): Promise<IGoalType[]> {
        return BaseApi.get(`${baseUrl}types`);
    }
    static async GetQtyClients(): Promise<number> {
        return await BaseApi.get(`${baseUrl}clientsQty`);
    }

    static async GetQtyProposalsAlreadyCreated(proposalTypeId?: number): Promise<number> {
        return await BaseApi.get(`${baseUrl}numberProposalInMonth`, { params: { proposalTypeId } });
    }

    static async GetGoalsTypesCreatedAndActive(): Promise<{ goalTypeId: GoalTypeEnum, proposalTypeId?: number }[]> {
        return await BaseApi.get(`${baseUrl}typesCreatedAndActive`);
    }

    static async getProposalTypesAvailable(currentId?: number): Promise<{ id: number, name: string }[]> {
        return await BaseApi.get(`${baseUrl}proposalTypesAvailable`, { params: { currentId } });
    }
    // #endregion
    // #region POST
    static async PostGoal({ type, value, proposalTypeId }: IGoalNew): Promise<IResponse> {
        return await BaseApi.post(`${baseUrl}`, {
            type,
            value,
            proposalTypeId
        });
    }
    // #endregion
    // #region PATCH
    static async PatchGoal(goalId: string, quantity: number|string, proposalTypeId?: number): Promise<IResponse> {
        return await BaseApi.patch(`${baseUrl}${goalId}`, {
            quantity,
            proposalTypeId
        });
    }
    static async PatchStatus({ goalId, statusId }: IUpdateStatus): Promise<boolean> {
        return await BaseApi.patch(`${baseUrl}`, {
            goalId,
            statusId
        });
    }
    // #endregion
}

export default GoalService;